<div [formGroup]="formGroup">
  <div class="declaration-box">
    <!-- <div>{{ declarationText }}</div> -->
    <mat-checkbox formControlName="acceptAccountDeclaration">
      <mat-label>I have read and agreed to the Sender ID Registry <a target="_blank" href="https://www.comreg.ie/media/2025/05/Sender-ID-Registry-Terms-and-Conditions-v1.0.pdf">Terms and Conditions.</a></mat-label>
    </mat-checkbox>
    @if (formGroup.invalid && formGroup.touched) {
      <mat-error>You need to sign up the declaration in order to create an account</mat-error>
    }
  </div>
</div>
